<template>
    <div class="trainServicesIndex">
        <banner :themeColor = 'themeColors'></banner>
        <div class="container">
            <div class="topTabBox">
                <div class="boxTit">线上课程学习中心</div>
                <div class="tabTit">
                    <div class="titItem" v-for="(item,titIndex) in onlineTitList" :key="item._id" :class="{active:item.active}" @click="tabTitClick(titIndex,item._id,'online')">{{ item.kcfl }}</div>
                </div>
                <div class="tabContent">
                    <div class="contentItem" v-for="(item,index) in onlineContentList" :key="item.id" @click="goPage('./courseDetail',item._id)">
                        <div class="imgBox">
                            <img :src="commenUrl+ item.kctp" v-if="item.kctp" alt="">  
                            <img class="defaultImg" src="../../assets/images/trainServices/defaultImg.png" v-else alt="">
                        </div>
                        <div class="contentTit">{{ item.kcmc }}</div>
                        <div class="contentDesc">{{ item.kcjj }}</div>
                    </div>
                </div>
                <div class="paginationBox">
                    <el-pagination background layout="prev, pager, next"  @size-change="e=>{sizeChange(e,'online')}"
                        @current-change="e=>{currentChange(e,'online')}"
                        :page-size="pageInfo.pageSize" :total="pageInfo.count" />
                </div>
            </div>
            <div class="botTabBox">
                <div class="boxTit">线下培训公告中心</div>
                <div class="tabTit">
                    <div class="titItem" v-for="(item,titIndex) in offlineTitList" :key="item._id" :class="{active:item.active}" @click="tabTitClick(titIndex,item._id,'offline')">{{ item.pxfl }}</div>
                </div>
                <div class="tabContent">
                    <div class="contentItem" v-for="(item,index) in offlineContentList" :key="item.id">
                        <div class="leftBox">
                            <div class="bigT">{{ item.day }}</div>
                            <div>{{ item.month }}<span class="gap">月</span>{{ item.year }}</div>
                        </div>
                        <div class="midBox" @click="goPage('./trainServicesDetail',item._id,item.status)">
                            <div class="tit">{{ item.pxmc }}</div>
                            <div class="desc">{{ item.pxjj }}</div>
                        </div>
                        <div class="rightBox">
                            <div class="btn colorBtn" v-if="item.status=='2'" @click="goPage('./trainServicesDetail/',item._id,item.status)">培训回顾</div>
                            <div class="btn" v-else @click="goPage('./trainServicesDetail',item._id,item.status)">立即报名</div>
                        </div>
                    </div>
                </div>
                <div class="paginationBox">
                    <el-pagination background layout="prev, pager, next"  @size-change="e=>{sizeChange(e,'offline')}"
                        @current-change="e=>{currentChange(e,'offline')}"
                        :page-size="pageInfo1.pageSize" :total="pageInfo1.count" />
                </div>
            </div>
        </div>
        <div class="btmBox">
            <div class="boxTit">定制化培训服务咨询</div>
            <customConsult :themeColor="themeColor" :offlineTitList="offlineTitList"></customConsult>
        </div>
    </div>
</template>
<script>
    import { ref, getCurrentInstance, reactive ,nextTick} from "vue";
    import { useRouter,useRoute } from "vue-router";
    import customConsult from "./components/customConsult.vue";
    import banner from '@/components/banner.vue'
    export default {
        name: "trainServices",
        props:{
            themeColor: {
                type: String,
                default: 'blue'
            },
        },
        components: {customConsult,banner},
        setup() {

            const { proxy } = getCurrentInstance();
            const router = useRouter();
            const route = useRoute()
            const themeColors = ref('#fff')
            const pageInfo = ref({
                pageSize:8,
                pageNo:1,
                count:0
            })
            const pageInfo1 = ref({
                pageSize:6,
                pageNo:1,
                count:0
            })
            // 线上课程
            const onlineTitList = ref([])
            // 获取线上课程类型
            const getOnlineTypeList = ()=>{
                proxy.$request({
                    url: 'QPSTZX_PXFW_COURSESTYPELIST',
                    method: "post",
                    data:{}
                }).then((res) => {
                    console.log(res);
                    if(res.data.code=='000'){
                        onlineTitList.value = res.data.result
                        nextTick(()=>{
                            if(onlineTitList.value.length>0){
                                onlineTitList.value[0].active = true
                                getContentList( onlineTitList.value[0]._id)
                            }
                        })
                        
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
            getOnlineTypeList()
            //获取线上课程内容列表
            const onlineContentList = ref([])
            const getContentList = (id)=>{
                proxy.$request({
                    url: 'QPSTZX_PXFW_COURSESFINDPAGE',
                    method: "post",
                    data:{
                        "kclb": id,
                        "pageInfo": pageInfo.value
                    }
                }).then((res) => {
                    console.log(res);
                    if(res.data.code=='000'){
                        onlineContentList.value = res.data.result.list
                        pageInfo.value.pageNo = res.data.result.pageNo
                        pageInfo.value.pageSize = res.data.result.pageSize
                        pageInfo.value.count = res.data.result.count
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
            //类型切换
            const currentOnlineId = ref('')
            const currentOfflineId = ref('')
            const tabTitClick = (titIndex,id,type) => {
                if(type=='online'){
                    currentOnlineId.value = id;
                    onlineTitList.value.forEach((item,index)=>{
                        item.active = index==titIndex?true:false
                    })
                    pageInfo.value.pageNo = 1
                    getContentList(currentOnlineId.value)
                }else{
                    currentOfflineId.value = id;
                    offlineTitList.value.forEach((item,index)=>{
                        item.active = index==titIndex?true:false
                    })
                    pageInfo1.value.pageNo = 1
                    getOfflineContentList(currentOfflineId.value)
                }
            }
            //分页事件
            const sizeChange = (e,type) => {
                if(type=='online'){
                    if (pageInfo.value.pageSize == e) return;
                    pageInfo.value.pageSize = e;
                    getContentList(currentOnlineId.value)
                }else{
                    if (pageInfo1.value.pageSize == e) return;
                    pageInfo1.value.pageSize = e;
                    getOfflineContentList(currentOfflineId.value)
                }
                
            };
            const currentChange = (e,type) => {
                if(type=='online'){
                    if (pageInfo.value.pageNo == e) return;
                    pageInfo.value.pageNo = e;
                    getContentList(currentOnlineId.value)
                }else{
                    if (pageInfo1.value.pageNo == e) return;
                    pageInfo1.value.pageNo = e;
                    getOfflineContentList(currentOfflineId.value)
                }
            };
            // 线下培训
            const offlineTitList = ref([])
            // 获取线下培训类型
            const getOfflineTypeList = ()=>{
                proxy.$request({
                    url: 'QPSTZX_XXPX_TRAINTYPELIST',
                    method: "post",
                    data:{}
                }).then((res) => {
                    console.log(res);
                    if(res.data.code=='000'){
                        offlineTitList.value = res.data.result
                        nextTick(()=>{
                            if(offlineTitList.value.length>0){
                                offlineTitList.value[0].active = true
                                getOfflineContentList( offlineTitList.value[0]._id)
                            }
                        })
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
            getOfflineTypeList()
            //获取线下培训内容列表
            const offlineContentList = ref([])
            const getOfflineContentList = (id)=>{
                proxy.$request({
                    url: 'QPSTZX_XXPX_TRAINTFINDPAGE',
                    method: "post",
                    data:{
                        "pxfl": id,
                        "pageInfo": pageInfo1.value
                    }
                }).then((res) => {
                    console.log(res);
                    if(res.data.code=='000'){
                        offlineContentList.value = res.data.result.list.map(item=>{
                            const dateStr = item.pxkssj
                            if (!dateStr) return {...item, year: '', month: '', day: '' };
                            const normalizedStr = dateStr.replace(/-/g, '/');
                            const [datePart] = normalizedStr.split(' '); 
                            const [year, month, day] = datePart.split('/'); 
                            return {
                                ...item,
                                year: year || '',
                                month: month || '',
                                day: day || ''
                            };
                        })
                        pageInfo1.value.pageNo = res.data.result.pageNo
                        pageInfo1.value.pageSize = res.data.result.pageSize
                        pageInfo1.value.count = res.data.result.count
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
             //页面跳转
            const goPage = (url,id,status) => {
                let str = '?id='+id
                if(status){
                    str = '?id='+id+'&status='+status
                }
                window.open(url+str);
            };
            return {
                onlineTitList,
                tabTitClick,
                currentOnlineId,
                currentOfflineId,
                pageInfo,
                pageInfo1,
                onlineContentList,
                sizeChange,
                currentChange,
                offlineTitList,
                offlineContentList,
                goPage,
                themeColors
            }
        }
    }
</script>
<style lang="less" scoped>
.trainServicesIndex{
    width: 100%;
    height: 100%;
    background: #F7F7F7 ;
    box-sizing: border-box;
    padding-bottom: 50px;
    div{
        box-sizing: border-box;
        color: #191919;
        font-size: 16px;
        line-height: 22px;
        font-family: PingFangSC, PingFang SC;
    }
    img{
        width: 100%;
        height: 100%;
    }
    .boxTit{
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
        text-align: center;
    }
    .container{
        .tabTit{
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 20px;
            .titItem{
                font-weight: 400;
                font-size: 18px;
                color: #191919;
                line-height: 28px;
                padding-bottom: 10px;
                margin:0 40px;
                cursor: pointer;
                &.active{
                    font-weight: 600;
                    font-size: 20px;
                    border-bottom: 3px solid #191919;;
                }
            }
        }
        .paginationBox{
            display: flex;
            justify-content: center;
        }
        .topTabBox{
            width: 1200px;
            margin: 0 auto;
            padding-bottom:60px;
            .boxTit{
                padding: 60px 0 30px;
            }
            .tabContent{
                display:flex;
                flex-wrap: wrap;
                gap: 40px 20px;
                min-height: 348px;
                .contentItem{
                    width: calc((100% - 60px) / 4);
                    box-sizing: border-box;
                    font-weight: 400;
                    cursor: pointer;
                    .imgBox{
                        width: 100%;
                        height: 223px;
                        background: #EEF1FF;
                        border-radius: 20px;
                        overflow: hidden;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 26px;
                        .defaultImg{
                            width: 247px;
                            height: 164px;
                        }
                    }
                    .contentTit{
                        font-weight: 600;
                        font-size: 24px;
                        line-height: 33px;
                        height: 33px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin-bottom: 10px;
                    }
                    .contentDesc{
                        width: 100%;
                        height: 56px;
                        line-height: 28px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
            .paginationBox{
                margin-top: 30px;
            }
        }
        .botTabBox{
            width: 100%;
            height: 850px;
            background-image: url(../../assets/images/trainServices/boxBgImg.png);
            background-size: cover;
            background-repeat: no-repeat;
            display: flex;
            flex-direction: column;
            padding-bottom: 50px;
            .paginationBox{
                margin-top: auto;
            }
            .boxTit{
                padding: 50px 0 30px;
                color: #FFFFFF;
            }
            .tabTit{
                .titItem{
                    color: #FFFFFF;
                    &.active{
                        border-bottom: 3px solid #FFFFFF;
                    }
                }
            }
            .tabContent{
                width: 1200px;
                margin: 0 auto;
                display: flex;
                flex-wrap: wrap;
                gap: 20px;
                .contentItem{
                    width: 590px;
                    height: 164px;
                    padding: 33px 20px 33px 20px;
                    background: linear-gradient( 133deg, #FFFFFF 0%, rgba(255,255,255,0.39) 100%);
                    border-radius: 20px;
                    display: flex;
                    .leftBox{
                        width:100px;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        justify-content: center;
                        align-items: center;
                        font-weight: 500;
                        font-size: 20px;
                        color: #595959;
                        line-height: 28px;
                        .bigT{
                            font-weight: 900;
                            font-size: 46px;
                            line-height: 56px;
                            color: #191919;
                        }
                        .gap{
                            margin-right: 8px;
                        }
                    }
                    .midBox{
                        flex: 1;
                        margin:0 20px;
                        cursor: pointer;
                        .tit{
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 33px;
                            margin-bottom: 15px;
                            max-width: 304px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .desc{
                            font-weight: 500;
                            font-size: 14px;
                            color: #595959;
                            line-height: 26px;
                            height: 52px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical; 
                        }
                    }
                    .rightBox{
                        width: 106px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        .btn{
                            width: 106px;
                            height: 34px;
                            border-radius: 17px;
                            border: 1px solid #191919;
                            text-align: center;
                            line-height: 34px;
                            font-size: 14px;
                            cursor: pointer;
                            background: transparent;
                        }
                        .colorBtn{
                            background: #191919;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
    }
    .btmBox{
        margin:0 auto;
        width: 1200px;
        .boxTit{
            padding: 60px 0 40px;
        }
    }
}
@media (min-width: 1680px) {
    .trainServices{
        .container{
            .topTabBox{
                width: 1600px;
            }
            .botTabBox{
                .tabContent{
                    width: 1600px;
                    .contentItem{
                        width: 790px;
                        height: 164px;
                        .midBox{
                            margin:0 30px;
                            .tit{
                                max-width: 484px;
                            }
                        }
                    }
                }
            }
        }
        .btmBox{
            width: 1600px;
        }
    }
}
</style>